import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditVender() {
  const [venderType, setVenderType] = useState("");
  const [name, setName] = useState();
  const [code, setCode] = useState();
  const [status, setStatus] = useState(1);
  let { id } = useParams();
  const classes = useStyles();
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [mac5code, setMAC5Code] = useState("");
  const [contact, setContact] = useState("");
  const EmpId = localStorage.getItem("EmpId");
  const [ModId, setModId] = useState("1");
  //fetch Data

  const data_params = { id: id };
  // console.log(id)
  const getData = async () => {
    try {
      const data = await api
        .post("api/vender/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              setVenderType(res.VenderType || "");
              setName(res.VenderName);
              setModId(res.ModId);
              setMAC5Code(res.VenderMAC5Code)
              setAddress(res.VenderAddress)
              setContact(res.VenderContactName)
              setEmail(res.VenderEmail)
              setTel(res.VenderTel)
              setCode(res.VenderNo)
              // res.Status.data.map((res) => {
              //   setF_t_status(res);
              //   console.log(res);
              // });
              setStatus(res.Status === true ? 1 : 0)
            });
          } else {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Vender");
                }
              });
            });
            // console.log("Nodata" + response);
          }
          //   console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // console.log(id);
    // GET request using axios inside useEffect React hook
    getData();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  const history = useHistory();
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ผู้ขาย
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Vender
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Vender
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{ name: "" }}
          validate={(values) => {
            const errors = {};
            if (!name || name === "") {
              errors.name = "Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                VenderId: id,
                VenderType: venderType,
                VenderNo: code,
                VenderName: name,
                ModId: ModId,
                status: status,
                VenderMAC5Code: mac5code,
                VenderAddress: address,
                VenderContactName: contact,
                VenderEmail: email,
                VenderTel: tel,
              };

              api
                .post("api/vender/update", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "แก้ไขข้อมูลผู้ขาย !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Vender");
                      }
                    });
                  });
                  console.log(respose);
                })
                .catch((err) => {
                  console.log(err);
                });

              // alert(JSON.stringify(f_t_no + f_t_name + f_t_status, null, 2));
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                แก้ไขผู้ขาย
              </h6>
              <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth required>
                    <InputLabel id="select_vender_type-label" shrink>
                      Vender Type
                    </InputLabel>
                    <Select
                      labelId="select_vender_type-label"
                      id="select_vender_type"
                      name="venderType"
                      value={venderType}
                      label="Vender Type"
                      displayEmpty
                      notched
                      onChange={(e) => setVenderType(e.target.value)}
                    >
                      <MenuItem value="" disabled>
                        <em>Select Vender Type</em>
                      </MenuItem>
                      <MenuItem value="Shipping Agent">Shipping Agent</MenuItem>
                      <MenuItem value="Trucking Agent">Trucking Agent</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={9}></Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    name="name"
                    label="Vender"
                    variant="outlined"
                    placeholder="Vender"
                    style={{ width: "100%" }}
                    onChange={(e) => setName(e.target.value)}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={name}
                    classes={{ root: !name ? classes.customOutline : null }}
                    required
                  />
                  {/* {errors.f_t_name && touched.f_t_name && errors.f_t_name} */}
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>
               

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Code"
                    label="Vender Code"
                    variant="outlined"
                    placeholder="Enter Vender Code"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setCode(e.target.value)
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={code}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="MAC5"
                    label="MAC-5 Code "
                    variant="outlined"
                    placeholder="Enter MAC-5 Code "
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setMAC5Code(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={mac5code}

                  />
                </Grid>
                
                <Grid item xs={12} sm={6} md={6}></Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    name="Address"
                    label="Address"
                    variant="outlined"
                    placeholder="Enter Address"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setAddress(e.target.value)
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={address}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Contact"
                    label="Contact Name"
                    variant="outlined"
                    placeholder="Enter Contact Name"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setContact(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={contact}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Email"
                    label="Email"
                    variant="outlined"
                    placeholder="Enter Email"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={email}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}></Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="Telephone"
                    label="Telephone"
                    variant="outlined"
                    placeholder="Enter Telephone"
                    style={{
                      width: "100%",

                    }}
                    onChange={(e) => {
                      setTel(e.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={tel}

                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3} >
                  {/* <TextField
                    label="FREIGHT TERMS NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter FREIGHT TERMS NO."
                    name="f_t_no"
                    style={{
                      width: "40%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={(e) => setF_t_no(e.target.value)}
                    onBlur={handleBlur}
                    value={f_t_no}
                  />
                  {errors.f_t_no && touched.f_t_no && errors.f_t_no} */}

                  <FormControl fullWidth>
                    <InputLabel id="select_status-label">Status</InputLabel>
                    <Select
                      name="status"
                      id="select_status"
                      value={status}
                      style={{
                        width: "100%",
                        // marginLeft: "10px",
                        // marginTop: "10px",
                        // marginBottom: "10px",
                      }}
                      label="Status"
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
